import React from "react";

const ArrowDown = () => {
  return (
    <svg
      width="11"
      height="6"
      viewBox="0 0 11 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.34874 5.39896L5.34871 5.399L5.35156 5.40155C5.44151 5.48195 5.55521 5.525 5.67344 5.525C5.7907 5.525 5.90701 5.48243 5.99627 5.39484L10.6832 0.984908C10.8681 0.81099 10.8681 0.525688 10.6832 0.351771C10.5036 0.182743 10.2166 0.182743 10.037 0.351771L10.0369 0.351807L5.67337 4.46032L1.30678 0.354712C1.30677 0.354703 1.30675 0.354685 1.30674 0.354676C1.12709 0.185675 0.840145 0.185693 0.660507 0.354712C0.475664 0.528629 0.475664 0.813931 0.660507 0.987848L5.34874 5.39896Z"
        fill="#1B1B1B"
        stroke="#1B1B1B"
        stroke-width="0.3"
      />
    </svg>
  );
};

export default ArrowDown;
